import { updateSelectedApPayeeIsBank } from '@/components/ApPayee/useChangeIsBankTransfer';
import { ApPayeeDetail } from 'ap-openapi';
import { useCallback } from 'react';

export const useSyncSelectedApPayeeIsBank = () => {
  const syncIsBank = useCallback(
    (selectedApPayee: ApPayeeDetail | undefined) => {
      if (!selectedApPayee) {
        updateSelectedApPayeeIsBank(false);
        return;
      }
      const isBankTransfer = selectedApPayee.payment_method === 'bank_transfer';
      updateSelectedApPayeeIsBank(isBankTransfer);
    },
    []
  );

  return syncIsBank;
};
